export const REWARDS_EVENTS_UPDATES = 'rewards_events_updates';
